export type Mods = Record<string, boolean | string | undefined>;

export function combineClasses(...classes: (string | undefined)[]): string {
  return classes.filter(Boolean).join(" ");
}
